var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isEnabled)?_c('div',{staticClass:"full-screen"},[_c('div',{staticClass:"show",on:{"click":_vm.toggleFull}},[_vm._m(0),_c('div',{staticClass:"text"},[_vm._v("全屏显示")])])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('i',{staticClass:"el-icon-full-screen iconFont"})])
}]

export { render, staticRenderFns }